/**CSS */
import './style.css';

export const Loader = ({ visible = false }) => {
    return visible 
    && (
        <div id="loader">
            <img src="https://www.compass.it/application/themes/compass/assets/img/loader.gif"/>
        </div>
    );
};